import {
  apiClient,
  type CustomerExEntity,
  type UpdateCustomerSiteGroupCodeDto
} from '@/libs/api'

export type UpdateCustomerSiteGroupCodeRequest = {
  tenantKey: string
  customerId: number
  dto: UpdateCustomerSiteGroupCodeDto
}

/**
 * VOC_PJ-630 #3669: 配送依頼作成の地点選択ポップアップから、
 * 選択中の荷主と地点をその場で関連付ける際に荷主側の関連地点関連付けコードを更新する。
 */
export const updateCustomerSiteGroupCode = async ({
  tenantKey,
  customerId,
  dto
}: UpdateCustomerSiteGroupCodeRequest): Promise<CustomerExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .customers._id(customerId)
    .site_group_code.$put({ body: dto })
  return data
}
